var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarketingOld = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_21885_82717)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.6766 6.432C15.2711 6.49998 14.8562 6.64063 14.4296 6.85394C13.9654 7.08601 13.6255 7.30402 12.7277 7.95099C11.6823 8.7058 11.04 9.03867 10.4258 9.14415L10.2617 9.17228V10.9679V12.7635L10.4258 12.7916C11.0845 12.9041 11.708 13.2417 13.084 14.2356C14.3452 15.1451 15.1422 15.4944 16.0376 15.5319C16.4057 15.5483 16.4807 15.5272 16.5674 15.3865C16.6143 15.3115 16.6143 15.2529 16.6143 10.9655C16.6143 6.74846 16.6119 6.61719 16.5698 6.55155C16.4807 6.41794 16.4197 6.39684 16.122 6.39918C15.9743 6.40153 15.7727 6.41559 15.6766 6.432Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33401 9.25677C7.2379 9.28022 7.06912 9.34351 6.95895 9.39977C6.79486 9.48181 6.71516 9.54276 6.53232 9.7256C6.3401 9.91782 6.29322 9.97876 6.2018 10.171C6.04474 10.4921 6.01192 10.6609 6.02364 11.043C6.03771 11.3923 6.08459 11.5657 6.24399 11.8564C6.3776 12.0955 6.70578 12.4096 6.9566 12.5339C7.32932 12.719 7.38558 12.7261 8.54357 12.7261H9.55858V10.968V9.20989L8.5342 9.21224C7.62468 9.21224 7.48637 9.21927 7.33401 9.25677Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3184 10.968V11.9736L17.384 11.9502C17.6161 11.8681 17.8856 11.5751 17.9747 11.3079C18.0474 11.0899 18.0357 10.7359 17.9466 10.5461C17.8364 10.3023 17.5973 10.0679 17.3793 9.98347L17.3184 9.96003V10.968Z",
  fill: "white"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.15234 15.0747C8.15234 16.65 8.15469 16.725 8.19688 16.7906C8.22032 16.8258 8.27189 16.8773 8.30706 16.9008C8.37035 16.943 8.43129 16.9453 9.2072 16.9453C9.9831 16.9453 10.0441 16.943 10.1073 16.9008C10.1425 16.8773 10.1941 16.8258 10.2175 16.7906C10.2597 16.725 10.2621 16.65 10.2621 15.0911C10.2621 13.6237 10.2574 13.4573 10.2245 13.4432C10.2035 13.4362 9.72994 13.4291 9.16969 13.4291H8.15234V15.0747Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_21885_82717",
  x1: 6.5,
  y1: 1,
  x2: 16,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1EAED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0C8FF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarketingOld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/marketing_old.c68a9f93bb57c5abd4e330dd0a561b8c.svg";